<template>
  <div
    class="rfp-rr-avg-cus-ratings-007-or rr-avg-customer-rating"
    :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
  >
    <div class="rfp-rr-avg-cus-ratings-008-or rr-avg-customer-rating-inner">
      <h3 class="rfp-rr-avg-cus-ratings-009-or rr-sub-title white">{{ headerTitle }}</h3>
      <div
        class="rfp-rr-avg-cus-ratings-010-or rr-avg-rating-content clear float-left mobile-width-assign"
      >
        <span
          class="rfp-rr-avg-cus-ratings-011-or rr-label float-left bold mobile-average-customer"
          >{{ labelOverall }}</span
        >
        <div class="rfp-rr-avg-cus-ratings-012-or review-stars">
          <refapp-star-rating
            :aria-label="starRatingAccessibleLabel"
            class="vue-star-rating"
            star-classes="vue-star-rating-star"
            :increment="starRatingIncrementValue"
            :max-rating="starRatingMaxRatingValue"
            :inactive-color="starRatingInactiveColor"
            :active-color="starRatingActiveColor"
            :star-size="starRatingStarSize"
            :rating="overallRating"
            readonly
          >
          </refapp-star-rating>
        </div>
        <span
          aria-hidden="true"
          class="rfp-rr-avg-cus-ratings-013-or rr-label-info float-right bold average-cus-ratings-mobile"
          >{{ overallRating }}</span
        >
      </div>
      <div
        v-if="showQualityOfProduct"
        class="rfp-rr-avg-cus-ratings-014-or rr-avg-rating-content clear float-left mobile-width-assign"
      >
        <span
          class="rfp-rr-avg-cus-ratings-015-or rr-label float-left bold mobile-average-customer-and-width"
          >{{ qualityOfProduct }}</span
        >
        <span class="rfp-rr-avg-cus-ratings-016-or rr-rating-bar-outer"
          ><span class="rr-rating-bar-inner" :style="{ width: ratingBar.Average }"></span
        ></span>
        <span class="ra-sr-only">{{ qualityOfProductAriaLabel }}</span>
        <span
          aria-hidden="true"
          class="rfp-rr-avg-cus-ratings-017-or rr-label-info float-right bold"
        >
          {{ ratingBar.count }}
        </span>
      </div>
      <div class="clear"></div>
      <div v-if="usersRecommendedText" class="rfp-rr-avg-cus-ratings-018-or rr-avg-rating-content">
        <div class="rfp-rr-avg-cus-ratings__users-recommended rr-label bold">
          {{ usersRecommendedText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RefappStarRating from '../../../../../shared/components/star-rating/refapp-star-rating.vue';

export default {
  name: 'rfp-ratings-average-customer-ratings',
  components: {
    RefappStarRating,
  },
  props: {
    headerTitle: {
      type: String,
      required: true,
    },
    labelOverall: {
      type: String,
      required: true,
    },
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
    qualityOfProduct: {
      type: String,
      required: true,
    },
    ratingBar: {
      type: Object,
      required: true,
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
    showQualityOfProduct: {
      type: Boolean,
      required: true,
    },
    usersRecommendedText: {
      type: String,
      default: '',
    },
    starRatingAccessibleLabel: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      overallRating: this.rating,
    };
  },
  computed: {
    qualityOfProductAriaLabel() {
      return (
        this.starRatingAccessibleLabel
          ?.replace('{{star}}', this.ratingBar.count)
          .replace('{{maxStars}}', this.starRatingMaxRatingValue) || null
      );
    },
  },
};
</script>
